import { createRouter, createWebHistory } from "vue-router";
import { ROLES } from "@/config/roles"


import ReceptionistDashboardPage from "./views/pages/ReceptionistDashboardPage.vue";
import PatientsPage from "./views/pages/PatientsPage.vue";
import TriageDashboardPage from "./views/pages/TriageDashboardPage.vue";
import ConsultantDashboardPage from "./views/pages/ConsultantDashboardPage.vue";
import ProceduresDashboardPage from "@/views/pages/ProceduresDashboardPage.vue"
import PatientRegistrationPageMobile from "./views/pages/PatientRegistrationPageMobile.vue";
import LabDashboardPage from "./views/pages/LabDashboardPage.vue";
import PharmacyDashboardPage from "./views/pages/PharmacyDashboardPage.vue";
import InventoryDashboardPage from "./views/pages/InventoryDashboardPage.vue";
import RadiologyDashboardPage from "./views/pages/RadiologyDashboardPage.vue";
import LabRequestDetails from "./views/pages/LabRequestDetails.vue";
import RadiologyRequestDetails from "./views/pages/RadiologyRequestDetails.vue";
import ConsultationMedicalHistoryPage from "./views/pages/ConsultationMedicalHistoryPage.vue";
import TriageMedicalHistoryPage from "./views/pages/TriageMedicalHistoryPage.vue";
import FacilityServicesDashboard from "./views/pages/FacilityServicesDashboard.vue";
import CashierDashboardPage from "./views/pages/CashierDashboardPage.vue";
import LoginPage from "./views/pages/LoginPage.vue";
import ViewPatient from "./views/pages/patients/ViewPatient.vue";
import AddFacilityService from "./components/forms/FacilityServices/AddFacilityService.vue";
import InventoryItemsPage from "./views/pages/InventoryItemsPage.vue";
import InventoryItemDetails from "./views/pages/InventoryItemDetails.vue";
import AddInventoryItemStock from "./views/pages/inventory/AddInventoryItemStock.vue";
import SelfRequest from "@/views/pages/visits/SelfRequest.vue";
import SystemBillingIndexPage from "@/views/pages/SystemBilling/SystemBillingIndexPage.vue";
import SystemBillOverDuePage from "@/views/pages/SystemBilling/SystemBillOverDuePage.vue";
import ListSchemesPage from "@/views/pages/insurance-managment/scheme-managment/ListSchemesPage.vue";
import SystemBillOverdueGeneralPage from "@/views/pages/SystemBilling/SystemBillOverdueGeneralPage.vue";

// FFS Management Components
import FFSManagementDashboardPage from "@/views/pages/ffs-management/FFSDashboardPage.vue"
import FFSCompanyDetails from "@/views/pages/ffs-management/FFSCompanyDetails.vue"

// Statistical Reports
import ReportsDashboardPage from "@/views/pages/statistical_reports/ReportsDashboardPage.vue"

// Facility Services
import DepartmentServices from "@/views/pages/facility_admin/facility_services/DepartmentServices.vue"
import LabDisciplinesView from "@/views/pages/facility_admin/facility_services/LabDisciplinesView.vue"

// Facility Settings
import FacilitySettingsDashboardPage from "@/views/pages/facility_admin/Settings/FacilitySettingsDashboardPage.vue"

// Laboratory
import MohStatutoryFormsPage from "./views/pages/MohStatutoryFormsPage.vue";
import QualityControlPage from "./views/pages/QualityControlPage.vue";
import QcLotDetailsPage from "./views/pages/QcLotDetailsPage.vue";

import LabEquipmentPage       from '@/views/pages/LabEquipmentPage.vue'
import LabEquipmentDetailPage from '@/views/pages/LabEquipmentDetailPage.vue'
import LabTestPanelsPage from '@/views/pages/LabTestPanelsPage.vue'

// Radiology
import RadiologyReportTemplatesPage from '@/views/pages/RadiologyReportTemplatesPage.vue'

const routes = [

  // Self-Registration Routes
  {
    path: "/self-register",
    name: "SelfRegister",
    component: () => import("@/views/pages/self_registration/SelfRegisterPage.vue"),
    meta: { title: 'Patient Self Registration', layout: 'empty', requiresAuth: false }
  },

  {
    path: "/",
    component: LoginPage,
    meta: { title: "Login", layout: "empty", requiresAuth: false },
  },
  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
    meta: { title: "Login", layout: "empty", requiresAuth: false },
  },
  {
    path: "/reception",
    name: "ReceptionistDashboardPage",
    component: ReceptionistDashboardPage,
    meta: { title: "Reception", requiresAuth: true },
  },
  {
    path: "/patient-information/:patientId",
    name: "PatientInformationPage",
    component: ViewPatient,
    meta: { title: "Patient Information", requiresAuth: true },
    props: true,
  },
  {
    path: "/patient-registaration",
    name: "PatientRegistrationPageMobile",
    component: PatientRegistrationPageMobile,
    meta: {
      title: "Patient Registration",
      layout: "empty",
      requiresAuth: true,
    },
  },
  {
    path: "/reception/visit-management",
    name: "ReceptionVisitManagementPage",
    component: () => import("@/views/pages/ReceptionVisitManagementPage.vue"),
    meta: { title: "Visit Records", requiresAuth: true },
  },

  {
    path: "/visit-management",
    name: "VisitManagementPage",
    component: () => import("@/views/pages/VisitManagementPage.vue"),
    meta: { title: "Visit Records", requiresAuth: true },
  },
  {
    path: "/archived-visits",
    name: "ArchivedVisitsPage",
    component: () => import("@/views/pages/ArchivedVisitsPage.vue"),
    meta: { title: "Archived Visits", requiresAuth: true },
  },
  {
    path: "/triage",
    name: "TriageDashboardPage",
    component: TriageDashboardPage,
    meta: { title: "Triage", requiresAuth: true, layout: 'triage' },
  },
  {
    path: "/triage/visit-management",
    name: "TriageVisitManagementPage",
    component: () => import("@/views/pages/VisitManagementPage.vue"),
    meta: { title: "Visit Records", requiresAuth: true, layout: "triage" },
  },
  {
    path: "/triage/archived-visits",
    name: "TriageArchivedVisitsPage",
    component: () => import("@/views/pages/ArchivedVisitsPage.vue"),
    meta: { title: "Archived Visits", requiresAuth: true, layout: "triage" },
  },
  {
    path: "/consultation",
    name: "ConsultantDashboardPage",
    component: ConsultantDashboardPage,
    meta: { title: "Consultation", requiresAuth: true, layout: 'consultation' },
  },
  {
    path: "/consultation/visit-management",
    name: "ConsultationVisitManagementPage",
    component: () => import("@/views/pages/VisitManagementPage.vue"),
    meta: { title: "Visit Records", requiresAuth: true, layout: "consultation" },
  },
  {
    path: "/consultation/archived-visits",
    name: "ConsultationArchivedVisitsPage",
    component: () => import("@/views/pages/ArchivedVisitsPage.vue"),
    meta: { title: "Archived Visits", requiresAuth: true, layout: "consultation" },
  },
  {
    path: "/procedures",
    name: "ProceduresDashboardPage",
    component: ProceduresDashboardPage,
    meta: { title: "Procedures", requiresAuth: true, layout: 'consultation' }
  },
  {
    path: "/consultation-medical-history/:patient_id",
    name: "ConsultationMedicalHistoryPage",
    component: ConsultationMedicalHistoryPage,
    meta: { title: "Medical History", requiresAuth: true, layout: 'consultation', allowedRoles: [ROLES.nurse, ROLES.doctor] },
  },
  {
    path: "/triage-medical-history/:patient_id",
    name: "TriageMedicalHistoryPage",
    component: TriageMedicalHistoryPage,
    meta: { title: "Medical History", requiresAuth: true, layout: 'triage', allowedRoles: [ROLES.nurse, ROLES.doctor] },
  },
  {
    path: "/triage/patient-information/:patientId",
    name: "TriagePatientInformationPage",
    component: ViewPatient,
    meta: { title: "Patient Information", requiresAuth: true, layout: 'triage', allowedRoles: [ROLES.nurse, ROLES.doctor] },
    props: true
  },
  {
    path: "/consultation/patient-information/:patientId",
    name: "ConsultationPatientInformationPage",
    component: ViewPatient,
    meta: { title: "Patient Information", requiresAuth: true, layout: 'consultation', allowedRoles: [ROLES.nurse, ROLES.doctor] },
    props: true
  },
  {
    path: "/laboratory",
    name: "LabDashboardPage",
    component: LabDashboardPage,
    meta: { title: "Laboratory", requiresAuth: true },
  },
  {
  path: "/moh-statutory-forms",
  name: "MohStatutoryFormsPage",
  component: MohStatutoryFormsPage,
  meta: { title: "MOH Statutory Forms", requiresAuth: true },
  },

  {
    path: "/radiology",
    name: "RadiologyDashboardPage",
    component: RadiologyDashboardPage,
    meta: { title: "Radiology", requiresAuth: true },
  },
  {
    path: "/lab-request-details/:lab_request_id",
    name: "LabRequestDetails",
    component: LabRequestDetails,
    meta: { title: "Laboratory", requiresAuth: true },
  },
  {
    path: "/pharmacy",
    name: "PharmacyDashboardPage",
    component: PharmacyDashboardPage,
    meta: { title: "Pharmacy", requiresAuth: true, layout: "pharmacy" },
  },
  {
    path: "/pharmacy/otc-sales",
    name: "OtcSales",
    component: () => import("@/views/pages/pharmacy/OtcSalesList.vue"),
    meta: {
      title: "OTC Sales",
      requiresAuth: true,
      layout: "pharmacy"
    }
  },
  {
    path: "/pharmacy/external-prescriptions",
    name: "ExternalPrescriptionPage",
    component: () => import("@/views/pages/pharmacy/ExternalPrescriptionPage.vue"),
    meta: {
      title: "External Prescriptions",
      requiresAuth: true,
      layout: "pharmacy"
    }
  },
  {
    path: "/inventory",
    name: "InventoryDashboardPage",
    component: InventoryDashboardPage,
    meta: { title: "Inventory", layout: "facility-admin", requiresAuth: true },
  },
  {
    path: "/cashier",
    name: "CashierDashboardPage",
    component: CashierDashboardPage,
    meta: { title: "Cashier", requiresAuth: true, layout: 'cashier' },
  },
  {
    path: "/cashier/archived-bills",
    name: "ArchivedBillsDashboardPage",
    component: () => import("@/views/pages/ArchivedDashboardPage.vue"),
    meta: { title: "Archived Bills", requiresAuth: true, layout: 'cashier' },
  },
  {
    path: "/radiology-request-details/:radiology_request_id",
    name: "RadiologyRequestDetails",
    component: RadiologyRequestDetails,
    meta: { title: "Radiology", requiresAuth: true },
  },
  {
    path: "/facility-services",
    name: "FacilityServicesDashboard",
    component: FacilityServicesDashboard,
    meta: {
      title: "Facility Services",
      layout: "facility-admin",
      requiresAuth: true,
    },
  },
  {
    path: "/add-facility-services",
    name: "AddFacilityService",
    component: AddFacilityService,
    meta: {
      title: "Set-Up Services",
      layout: "facility-admin",
      requiresAuth: true,
    },
  },
  {
    path: "/add-inventory-items",
    name: "InventoryItemsPage",
    component: InventoryItemsPage,
    meta: {
      title: "Inventory Items",
      layout: "facility-admin",
      requiresAuth: true,
    },
  },
  {
    path: "/view-inventory-items/:id",
    name: "InventoryItemDetails",
    component: InventoryItemDetails,
    meta: {
      title: "Inventory Details",
      layout: "facility-admin",
      requiresAuth: true,
    },
    props: true,
  },
  {
  path: "/facility-admin/moh-statutory-forms",
  name: "FacilityAdminMohStatutoryFormsPage",
  component: MohStatutoryFormsPage,
  meta: { title: "MOH Statutory Forms", requiresAuth: true, layout: "facility-admin" },
  },

  {
    path: "/add-inventory-item-stock/:id",
    name: "AddInventoryItemStock",
    component: AddInventoryItemStock,
    meta: {
      title: "Add Inventory Item Stock",
      layout: "facility-admin",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    beforeEnter: (to, from, next) => {
      const userType = JSON.parse(localStorage.getItem("user"))?.UserType;
      if (userType === ROLES.receptionist) {
        next("/reception");
      } else if (userType === ROLES.nurse) {
        next("/triage");
      } else if (userType === ROLES.doctor) {
        next("/consultation");
      } else if (userType === ROLES.lab_technician) {
        next("/laboratory");
      } else if (userType === ROLES.facility_admin) {
        next("/facility-services");
      } else if (userType === ROLES.radiologist) {
        next("/radiology");
      } else if (userType === ROLES.cashier) {
        next("/cashier");
      } else if (userType === ROLES.pharmacist) {
        next("/pharmacy");
      } else {
        next("/");
      }
    },
  },
  {
    path: "/patients",
    name: "PatientsPage",
    component: PatientsPage,
    meta: { title: "Patients", requiresAuth: true },
  },
  {
    path: "/triage/patients",
    name: "TriagePatientsPage",
    component: PatientsPage,
    meta: { title: "Patients", requiresAuth: true, layout: "triage", allowedRoles: ["Nurse", "Doctor"] },
  },
  {
    path: "/consultation/patients",
    name: "ConsultationPatientsPage",
    component: PatientsPage,
    meta: { title: "Patients", requiresAuth: true, layout: "consultation", allowedRoles: ["Nurse", "Doctor"] },
  },
  {
    path: "/self-request",
    name: "SelfRequest",
    component: SelfRequest,
    meta: { title: "Self Request", requiresAuth: true },
  },
  {
    path: '/system-billing',
    name: 'SystemBills',
    component: SystemBillingIndexPage,
    meta: {title: "SystemBills", requiresAuth: true },
  },
  {
    path: '/system-bill-overdue',
    name: 'SystemBillsOverdue',
    component: SystemBillOverDuePage,
    meta: {title: "System Bill Overdue", layout: "empty", requiresAuth: true },
  },
  {
    path: '/general-system-bill-overdue',
    name: 'GeneralSystemBillsOverdue',
    component: SystemBillOverdueGeneralPage,
    meta: {title: "System Bill Overdue", layout: "empty", requiresAuth: true },
  },
  {
    path: '/facility-schemes',
    name: 'FacilitySchemes',
    component: ListSchemesPage,
    meta: {title: "Facility Schemes", layout: "facility-admin", requiresAuth: true },
  },
  {
    path: '/fee-for-services',
    name: "Fee For Service",
    component: FFSManagementDashboardPage,
    meta: {
      title: "Fee For Services",
      layout: "facility-admin",
      requiresAuth: true
    }
  },
  {
    path: '/companies/:id',
    name: 'FFSCompanyDetails',
    component: FFSCompanyDetails,
    meta: {
      title: "Fee For Services",
      layout: "facility-admin",
      requiresAuth: true
    }
  },
  {
    path: '/statistical-reports',
    name: 'ReportsDashboardPage',
    component: ReportsDashboardPage,
    meta: {
      title: 'Statistical Reports',
      layout: 'facility-admin',
      requiresAuth: true
    }
  },
  {
    path: '/facility-services/department/:departmentId/:departmentName/lab-disciplines',
    name: 'LabDisciplines',
    component: LabDisciplinesView,
    meta: {
      title: 'Lab Disciplines',
      layout: 'facility-admin',
      requiresAuth: true
    }
  },
  {
    path: '/facility-services/department/:departmentId/:departmentName/discipline/:discipline',
    name: 'DisciplineServices',
    component: DepartmentServices,
    meta: {
      title: 'Discipline Services',
      layout: 'facility-admin',
      requiresAuth: true
    }
  },

  {
    path: '/facility-services/department/:departmentId/:departmentName',
    name: 'DepartmentServices',
    component: DepartmentServices,
    meta: {
      layout: 'facility-admin',
      requiresAuth: true
    }
  },
  {
    path: '/facility-settings',
    name: 'FacilitySettings',
    component: FacilitySettingsDashboardPage,
    meta: {
      layout: 'facility-admin',
      requiresAuth: true
    }
  },
  {
    path: "/quality-control",
    name: "QualityControlPage",
    component: QualityControlPage,
    meta: { title: "Quality Control", requiresAuth: true }
  },
  {
    path: "/quality-control/lot/:id",
    name: "QcLotDetailsPage",
    component: QcLotDetailsPage,
    meta: { title: "QC Lot Details", requiresAuth: true },
  },
  {
    path: '/lab/equipment',
    component: LabEquipmentPage,
    meta: { title: "Lab Equipment", requiresAuth: true }
  },

  {
    path: '/lab/equipment/:id',
    component: LabEquipmentDetailPage,
    meta: { title: "Lab Equipment Details", requiresAuth: true }
  },

  {
    path: '/lab/test-panels',
    component: LabTestPanelsPage,
    meta: { title: "Lab Test Panels", requiresAuth: true }
  },

  {
    path: '/radiology/report-templates',
    name: 'RadiologyReportTemplatesPage',
    component: RadiologyReportTemplatesPage,
    meta: { title: 'Report Templates', requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
});

// Navigation Guard
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  const userString = localStorage.getItem("user");
  let user = null;

  if (userString && userString !== 'undefined') {
    try {
      user = JSON.parse(userString);
    } catch (error) {
      console.error("Error parsing user data in router:", error);
    }
  }

  const isTokenExpired = (token) => {
    if (!token) return true;
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const currentTime = Math.floor(Date.now() / 1000);
      return payload.exp < currentTime;
    } catch (error) {
      return true;
    }
  };

  const isAuthenticated = token && user && !isTokenExpired(token);

  // 1. Auth check — redirect unauthenticated users to login
  if (to.meta.requiresAuth && !isAuthenticated) {
    return next("/login");
  }

  // 2. Role check — redirect unauthorized roles back to their own dashboard
  if (to.meta.allowedRoles && isAuthenticated) {
    const userType = user?.UserType;
    if (!to.meta.allowedRoles.includes(userType)) {
      return next("/dashboard");
    }
  }

  next();
});

export default router;
